var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMusic = function SvgMusic(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21q-1.65 0-2.825-1.175T6 17t1.175-2.825T10 13q.575 0 1.063.137.487.138.937.413V4q0-.424.287-.712A.97.97 0 0 1 13 3h4q.424 0 .712.288Q18 3.575 18 4v2q0 .424-.288.713A.97.97 0 0 1 17 7h-3v10q0 1.65-1.175 2.825T10 21"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMusic);
export { ForwardRef as ReactComponent };